var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M22.817 35.863C16.155 35.097 11 29.845 11 23.479 11 16.587 17.044 11 24.5 11S38 16.587 38 23.48c0 6.043-4.647 11.083-10.818 12.232L24.925 38l-2.108-2.137zM18.544 17.44a1.2 1.2 0 00-1.191 1.208 1.2 1.2 0 001.191 1.207h11.912a1.2 1.2 0 001.191-1.207 1.2 1.2 0 00-1.191-1.208H18.544zm0 4.83a1.2 1.2 0 00-1.191 1.208 1.2 1.2 0 001.191 1.208h11.912a1.2 1.2 0 001.191-1.208 1.2 1.2 0 00-1.191-1.207H18.544zm0 4.831a1.2 1.2 0 00-1.191 1.208 1.2 1.2 0 001.191 1.208h5.559a1.2 1.2 0 001.191-1.208 1.2 1.2 0 00-1.191-1.208h-5.559z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
